import { useEffect, useState } from 'react'
import { AmbassadorService } from '../../services/ambassador'
import { concourseIdTest } from '../../constants/activity-constants'
import userSessionStorage from '../userSessionStorage'

const UseGetInscription = () => {
  const [isAmbassador, setIsAmbassador] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const session = new userSessionStorage()

  const fetch = async () => {
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const response = await AmbassadorService.getInscription(concourseIdTest)
      if (response.status === 200) {
        setIsAmbassador(true)
        setIsLoading(false)
      }else{
        setIsLoading(false)
      }
    } else {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])

  return [isAmbassador, isLoading]
}

export default UseGetInscription
